
import React from 'react';
import { AuthScreen } from '../../types';
import logoFull from '../../assets/logo-full.png';
import iconTeal from '../../assets/icon-teal.png';
import Footer from '../../components/Footer';

interface SuccessProps {
  onNavigate: (screen: AuthScreen) => void;
}

const Success: React.FC<SuccessProps> = ({ onNavigate }) => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <header className="px-8 py-6">
        <div className="flex items-center gap-2">
          <img src={logoFull} alt="NOGIET" className="h-8 w-auto" />
        </div>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center p-8">
        <div className="w-full max-w-sm text-center space-y-8">
          <div className="flex justify-center">
            <img src={iconTeal} alt="Reset Password" className="w-20 h-20" />
          </div>

          <div className="space-y-2">
            <h2 className="text-3xl font-bold text-gray-900">Password Reset</h2>
            <p className="text-gray-500">Password successfully reset. Please sign in to continue</p>
          </div>

          <button
            onClick={() => onNavigate(AuthScreen.LOGIN)}
            className="nogiet-button nogiet-button-primary inline-flex w-full"
          >
            Sign in
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Success;
